// source: proto/entity/issue.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() {
  if (this) { return this; }
  if (typeof window !== 'undefined') { return window; }
  if (typeof global !== 'undefined') { return global; }
  if (typeof self !== 'undefined') { return self; }
  return Function('return this')();
}.call(null));

var proto_common_crudFields_pb = require('../../proto/common/crudFields_pb.js');
goog.object.extend(proto, proto_common_crudFields_pb);
var proto_common_objectID_pb = require('../../proto/common/objectID_pb.js');
goog.object.extend(proto, proto_common_objectID_pb);
var proto_email_email_pb = require('../../proto/email/email_pb.js');
goog.object.extend(proto, proto_email_email_pb);
var proto_entity_anomaly_pb = require('../../proto/entity/anomaly_pb.js');
goog.object.extend(proto, proto_entity_anomaly_pb);
var proto_entity_comment_pb = require('../../proto/entity/comment_pb.js');
goog.object.extend(proto, proto_entity_comment_pb);
var proto_entity_site_pb = require('../../proto/entity/site_pb.js');
goog.object.extend(proto, proto_entity_site_pb);
var proto_entity_user_pb = require('../../proto/entity/user_pb.js');
goog.object.extend(proto, proto_entity_user_pb);
var google_protobuf_wrappers_pb = require('google-protobuf/google/protobuf/wrappers_pb.js');
goog.object.extend(proto, google_protobuf_wrappers_pb);
goog.exportSymbol('proto.entity.Issue', null, global);
goog.exportSymbol('proto.entity.IssueDetails', null, global);
goog.exportSymbol('proto.entity.IssueDisposition', null, global);
goog.exportSymbol('proto.entity.IssueDisposition.Options', null, global);
goog.exportSymbol('proto.entity.IssueState', null, global);
goog.exportSymbol('proto.entity.IssueState.Options', null, global);
goog.exportSymbol('proto.entity.NewIssue', null, global);
goog.exportSymbol('proto.entity.UpdateIssueAction', null, global);
goog.exportSymbol('proto.entity.UpdateIssueAction.ActionCase', null, global);
goog.exportSymbol('proto.entity.UpdateIssueAction.AddIssueCommentAction', null, global);
goog.exportSymbol('proto.entity.UpdateIssueAction.ChangeStateAction', null, global);
goog.exportSymbol('proto.entity.UpdateIssueAction.DeleteIssueCommentAction', null, global);
goog.exportSymbol('proto.entity.UpdateIssueAction.EditIssueCommentAction', null, global);
goog.exportSymbol('proto.entity.UpdateIssueAction.UpdateAssigneeAction', null, global);
goog.exportSymbol('proto.entity.UpdateIssueAction.UpdateAttributesAction', null, global);
goog.exportSymbol('proto.entity.UpdateIssueAction.UpdateTagsAction', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.NewIssue = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.entity.NewIssue.repeatedFields_, null);
};
goog.inherits(proto.entity.NewIssue, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.NewIssue.displayName = 'proto.entity.NewIssue';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.Issue = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.entity.Issue.repeatedFields_, null);
};
goog.inherits(proto.entity.Issue, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.Issue.displayName = 'proto.entity.Issue';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.IssueDetails = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.entity.IssueDetails.repeatedFields_, null);
};
goog.inherits(proto.entity.IssueDetails, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.IssueDetails.displayName = 'proto.entity.IssueDetails';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.IssueState = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.IssueState, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.IssueState.displayName = 'proto.entity.IssueState';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.IssueDisposition = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.IssueDisposition, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.IssueDisposition.displayName = 'proto.entity.IssueDisposition';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.UpdateIssueAction = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.entity.UpdateIssueAction.oneofGroups_);
};
goog.inherits(proto.entity.UpdateIssueAction, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.UpdateIssueAction.displayName = 'proto.entity.UpdateIssueAction';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.UpdateIssueAction.ChangeStateAction = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.UpdateIssueAction.ChangeStateAction, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.UpdateIssueAction.ChangeStateAction.displayName = 'proto.entity.UpdateIssueAction.ChangeStateAction';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.UpdateIssueAction.UpdateTagsAction = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.entity.UpdateIssueAction.UpdateTagsAction.repeatedFields_, null);
};
goog.inherits(proto.entity.UpdateIssueAction.UpdateTagsAction, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.UpdateIssueAction.UpdateTagsAction.displayName = 'proto.entity.UpdateIssueAction.UpdateTagsAction';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.UpdateIssueAction.UpdateAttributesAction = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.entity.UpdateIssueAction.UpdateAttributesAction.repeatedFields_, null);
};
goog.inherits(proto.entity.UpdateIssueAction.UpdateAttributesAction, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.UpdateIssueAction.UpdateAttributesAction.displayName = 'proto.entity.UpdateIssueAction.UpdateAttributesAction';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.UpdateIssueAction.UpdateAssigneeAction = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.UpdateIssueAction.UpdateAssigneeAction, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.UpdateIssueAction.UpdateAssigneeAction.displayName = 'proto.entity.UpdateIssueAction.UpdateAssigneeAction';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.UpdateIssueAction.AddIssueCommentAction = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.UpdateIssueAction.AddIssueCommentAction, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.UpdateIssueAction.AddIssueCommentAction.displayName = 'proto.entity.UpdateIssueAction.AddIssueCommentAction';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.UpdateIssueAction.DeleteIssueCommentAction = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.UpdateIssueAction.DeleteIssueCommentAction, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.UpdateIssueAction.DeleteIssueCommentAction.displayName = 'proto.entity.UpdateIssueAction.DeleteIssueCommentAction';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.UpdateIssueAction.EditIssueCommentAction = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.UpdateIssueAction.EditIssueCommentAction, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.UpdateIssueAction.EditIssueCommentAction.displayName = 'proto.entity.UpdateIssueAction.EditIssueCommentAction';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.entity.NewIssue.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.NewIssue.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.NewIssue.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.NewIssue} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.NewIssue.toObject = function(includeInstance, msg) {
  var f, obj = {
    siteSelector: (f = msg.getSiteSelector()) && proto_entity_site_pb.SiteSelector.toObject(includeInstance, f),
    newAnomaliesList: jspb.Message.toObjectList(msg.getNewAnomaliesList(),
    proto_entity_anomaly_pb.NewAnomaly.toObject, includeInstance),
    newEmail: (f = msg.getNewEmail()) && proto_email_email_pb.NewEmail.toObject(includeInstance, f),
    hash: (f = msg.getHash()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    issueDetails: (f = msg.getIssueDetails()) && proto.entity.IssueDetails.toObject(includeInstance, f),
    assigneeUser: (f = msg.getAssigneeUser()) && proto_entity_user_pb.UserSelector.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.NewIssue}
 */
proto.entity.NewIssue.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.NewIssue;
  return proto.entity.NewIssue.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.NewIssue} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.NewIssue}
 */
proto.entity.NewIssue.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_site_pb.SiteSelector;
      reader.readMessage(value,proto_entity_site_pb.SiteSelector.deserializeBinaryFromReader);
      msg.setSiteSelector(value);
      break;
    case 2:
      var value = new proto_entity_anomaly_pb.NewAnomaly;
      reader.readMessage(value,proto_entity_anomaly_pb.NewAnomaly.deserializeBinaryFromReader);
      msg.addNewAnomalies(value);
      break;
    case 3:
      var value = new proto_email_email_pb.NewEmail;
      reader.readMessage(value,proto_email_email_pb.NewEmail.deserializeBinaryFromReader);
      msg.setNewEmail(value);
      break;
    case 4:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setHash(value);
      break;
    case 5:
      var value = new proto.entity.IssueDetails;
      reader.readMessage(value,proto.entity.IssueDetails.deserializeBinaryFromReader);
      msg.setIssueDetails(value);
      break;
    case 6:
      var value = new proto_entity_user_pb.UserSelector;
      reader.readMessage(value,proto_entity_user_pb.UserSelector.deserializeBinaryFromReader);
      msg.setAssigneeUser(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.NewIssue.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.NewIssue.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.NewIssue} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.NewIssue.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSiteSelector();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_entity_site_pb.SiteSelector.serializeBinaryToWriter
    );
  }
  f = message.getNewAnomaliesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto_entity_anomaly_pb.NewAnomaly.serializeBinaryToWriter
    );
  }
  f = message.getNewEmail();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto_email_email_pb.NewEmail.serializeBinaryToWriter
    );
  }
  f = message.getHash();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getIssueDetails();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.entity.IssueDetails.serializeBinaryToWriter
    );
  }
  f = message.getAssigneeUser();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto_entity_user_pb.UserSelector.serializeBinaryToWriter
    );
  }
};


/**
 * optional SiteSelector site_selector = 1;
 * @return {?proto.entity.SiteSelector}
 */
proto.entity.NewIssue.prototype.getSiteSelector = function() {
  return /** @type{?proto.entity.SiteSelector} */ (
    jspb.Message.getWrapperField(this, proto_entity_site_pb.SiteSelector, 1));
};


/**
 * @param {?proto.entity.SiteSelector|undefined} value
 * @return {!proto.entity.NewIssue} returns this
*/
proto.entity.NewIssue.prototype.setSiteSelector = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.NewIssue} returns this
 */
proto.entity.NewIssue.prototype.clearSiteSelector = function() {
  return this.setSiteSelector(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.NewIssue.prototype.hasSiteSelector = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated NewAnomaly new_anomalies = 2;
 * @return {!Array<!proto.entity.NewAnomaly>}
 */
proto.entity.NewIssue.prototype.getNewAnomaliesList = function() {
  return /** @type{!Array<!proto.entity.NewAnomaly>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto_entity_anomaly_pb.NewAnomaly, 2));
};


/**
 * @param {!Array<!proto.entity.NewAnomaly>} value
 * @return {!proto.entity.NewIssue} returns this
*/
proto.entity.NewIssue.prototype.setNewAnomaliesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.entity.NewAnomaly=} opt_value
 * @param {number=} opt_index
 * @return {!proto.entity.NewAnomaly}
 */
proto.entity.NewIssue.prototype.addNewAnomalies = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.entity.NewAnomaly, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.entity.NewIssue} returns this
 */
proto.entity.NewIssue.prototype.clearNewAnomaliesList = function() {
  return this.setNewAnomaliesList([]);
};


/**
 * optional email.NewEmail new_email = 3;
 * @return {?proto.email.NewEmail}
 */
proto.entity.NewIssue.prototype.getNewEmail = function() {
  return /** @type{?proto.email.NewEmail} */ (
    jspb.Message.getWrapperField(this, proto_email_email_pb.NewEmail, 3));
};


/**
 * @param {?proto.email.NewEmail|undefined} value
 * @return {!proto.entity.NewIssue} returns this
*/
proto.entity.NewIssue.prototype.setNewEmail = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.NewIssue} returns this
 */
proto.entity.NewIssue.prototype.clearNewEmail = function() {
  return this.setNewEmail(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.NewIssue.prototype.hasNewEmail = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional google.protobuf.StringValue hash = 4;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.entity.NewIssue.prototype.getHash = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 4));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.entity.NewIssue} returns this
*/
proto.entity.NewIssue.prototype.setHash = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.NewIssue} returns this
 */
proto.entity.NewIssue.prototype.clearHash = function() {
  return this.setHash(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.NewIssue.prototype.hasHash = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional IssueDetails issue_details = 5;
 * @return {?proto.entity.IssueDetails}
 */
proto.entity.NewIssue.prototype.getIssueDetails = function() {
  return /** @type{?proto.entity.IssueDetails} */ (
    jspb.Message.getWrapperField(this, proto.entity.IssueDetails, 5));
};


/**
 * @param {?proto.entity.IssueDetails|undefined} value
 * @return {!proto.entity.NewIssue} returns this
*/
proto.entity.NewIssue.prototype.setIssueDetails = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.NewIssue} returns this
 */
proto.entity.NewIssue.prototype.clearIssueDetails = function() {
  return this.setIssueDetails(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.NewIssue.prototype.hasIssueDetails = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional UserSelector assignee_user = 6;
 * @return {?proto.entity.UserSelector}
 */
proto.entity.NewIssue.prototype.getAssigneeUser = function() {
  return /** @type{?proto.entity.UserSelector} */ (
    jspb.Message.getWrapperField(this, proto_entity_user_pb.UserSelector, 6));
};


/**
 * @param {?proto.entity.UserSelector|undefined} value
 * @return {!proto.entity.NewIssue} returns this
*/
proto.entity.NewIssue.prototype.setAssigneeUser = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.NewIssue} returns this
 */
proto.entity.NewIssue.prototype.clearAssigneeUser = function() {
  return this.setAssigneeUser(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.NewIssue.prototype.hasAssigneeUser = function() {
  return jspb.Message.getField(this, 6) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.entity.Issue.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.Issue.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.Issue.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.Issue} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.Issue.toObject = function(includeInstance, msg) {
  var f, obj = {
    siteId: (f = msg.getSiteId()) && proto_common_objectID_pb.ObjectID.toObject(includeInstance, f),
    issueId: (f = msg.getIssueId()) && proto_common_objectID_pb.ObjectID.toObject(includeInstance, f),
    anomaliesList: jspb.Message.toObjectList(msg.getAnomaliesList(),
    proto_entity_anomaly_pb.Anomaly.toObject, includeInstance),
    crudFields: (f = msg.getCrudFields()) && proto_common_crudFields_pb.CRUDFields.toObject(includeInstance, f),
    hash: (f = msg.getHash()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    issueDetails: (f = msg.getIssueDetails()) && proto.entity.IssueDetails.toObject(includeInstance, f),
    assigneeUserId: (f = msg.getAssigneeUserId()) && proto_common_objectID_pb.ObjectID.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.Issue}
 */
proto.entity.Issue.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.Issue;
  return proto.entity.Issue.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.Issue} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.Issue}
 */
proto.entity.Issue.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_common_objectID_pb.ObjectID;
      reader.readMessage(value,proto_common_objectID_pb.ObjectID.deserializeBinaryFromReader);
      msg.setSiteId(value);
      break;
    case 2:
      var value = new proto_common_objectID_pb.ObjectID;
      reader.readMessage(value,proto_common_objectID_pb.ObjectID.deserializeBinaryFromReader);
      msg.setIssueId(value);
      break;
    case 3:
      var value = new proto_entity_anomaly_pb.Anomaly;
      reader.readMessage(value,proto_entity_anomaly_pb.Anomaly.deserializeBinaryFromReader);
      msg.addAnomalies(value);
      break;
    case 4:
      var value = new proto_common_crudFields_pb.CRUDFields;
      reader.readMessage(value,proto_common_crudFields_pb.CRUDFields.deserializeBinaryFromReader);
      msg.setCrudFields(value);
      break;
    case 5:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setHash(value);
      break;
    case 6:
      var value = new proto.entity.IssueDetails;
      reader.readMessage(value,proto.entity.IssueDetails.deserializeBinaryFromReader);
      msg.setIssueDetails(value);
      break;
    case 7:
      var value = new proto_common_objectID_pb.ObjectID;
      reader.readMessage(value,proto_common_objectID_pb.ObjectID.deserializeBinaryFromReader);
      msg.setAssigneeUserId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.Issue.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.Issue.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.Issue} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.Issue.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSiteId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_common_objectID_pb.ObjectID.serializeBinaryToWriter
    );
  }
  f = message.getIssueId();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto_common_objectID_pb.ObjectID.serializeBinaryToWriter
    );
  }
  f = message.getAnomaliesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto_entity_anomaly_pb.Anomaly.serializeBinaryToWriter
    );
  }
  f = message.getCrudFields();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto_common_crudFields_pb.CRUDFields.serializeBinaryToWriter
    );
  }
  f = message.getHash();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getIssueDetails();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.entity.IssueDetails.serializeBinaryToWriter
    );
  }
  f = message.getAssigneeUserId();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto_common_objectID_pb.ObjectID.serializeBinaryToWriter
    );
  }
};


/**
 * optional common.ObjectID site_id = 1;
 * @return {?proto.common.ObjectID}
 */
proto.entity.Issue.prototype.getSiteId = function() {
  return /** @type{?proto.common.ObjectID} */ (
    jspb.Message.getWrapperField(this, proto_common_objectID_pb.ObjectID, 1));
};


/**
 * @param {?proto.common.ObjectID|undefined} value
 * @return {!proto.entity.Issue} returns this
*/
proto.entity.Issue.prototype.setSiteId = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.Issue} returns this
 */
proto.entity.Issue.prototype.clearSiteId = function() {
  return this.setSiteId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.Issue.prototype.hasSiteId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional common.ObjectID issue_id = 2;
 * @return {?proto.common.ObjectID}
 */
proto.entity.Issue.prototype.getIssueId = function() {
  return /** @type{?proto.common.ObjectID} */ (
    jspb.Message.getWrapperField(this, proto_common_objectID_pb.ObjectID, 2));
};


/**
 * @param {?proto.common.ObjectID|undefined} value
 * @return {!proto.entity.Issue} returns this
*/
proto.entity.Issue.prototype.setIssueId = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.Issue} returns this
 */
proto.entity.Issue.prototype.clearIssueId = function() {
  return this.setIssueId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.Issue.prototype.hasIssueId = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated Anomaly anomalies = 3;
 * @return {!Array<!proto.entity.Anomaly>}
 */
proto.entity.Issue.prototype.getAnomaliesList = function() {
  return /** @type{!Array<!proto.entity.Anomaly>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto_entity_anomaly_pb.Anomaly, 3));
};


/**
 * @param {!Array<!proto.entity.Anomaly>} value
 * @return {!proto.entity.Issue} returns this
*/
proto.entity.Issue.prototype.setAnomaliesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.entity.Anomaly=} opt_value
 * @param {number=} opt_index
 * @return {!proto.entity.Anomaly}
 */
proto.entity.Issue.prototype.addAnomalies = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.entity.Anomaly, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.entity.Issue} returns this
 */
proto.entity.Issue.prototype.clearAnomaliesList = function() {
  return this.setAnomaliesList([]);
};


/**
 * optional common.CRUDFields crud_fields = 4;
 * @return {?proto.common.CRUDFields}
 */
proto.entity.Issue.prototype.getCrudFields = function() {
  return /** @type{?proto.common.CRUDFields} */ (
    jspb.Message.getWrapperField(this, proto_common_crudFields_pb.CRUDFields, 4));
};


/**
 * @param {?proto.common.CRUDFields|undefined} value
 * @return {!proto.entity.Issue} returns this
*/
proto.entity.Issue.prototype.setCrudFields = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.Issue} returns this
 */
proto.entity.Issue.prototype.clearCrudFields = function() {
  return this.setCrudFields(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.Issue.prototype.hasCrudFields = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional google.protobuf.StringValue hash = 5;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.entity.Issue.prototype.getHash = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 5));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.entity.Issue} returns this
*/
proto.entity.Issue.prototype.setHash = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.Issue} returns this
 */
proto.entity.Issue.prototype.clearHash = function() {
  return this.setHash(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.Issue.prototype.hasHash = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional IssueDetails issue_details = 6;
 * @return {?proto.entity.IssueDetails}
 */
proto.entity.Issue.prototype.getIssueDetails = function() {
  return /** @type{?proto.entity.IssueDetails} */ (
    jspb.Message.getWrapperField(this, proto.entity.IssueDetails, 6));
};


/**
 * @param {?proto.entity.IssueDetails|undefined} value
 * @return {!proto.entity.Issue} returns this
*/
proto.entity.Issue.prototype.setIssueDetails = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.Issue} returns this
 */
proto.entity.Issue.prototype.clearIssueDetails = function() {
  return this.setIssueDetails(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.Issue.prototype.hasIssueDetails = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional common.ObjectID assignee_user_id = 7;
 * @return {?proto.common.ObjectID}
 */
proto.entity.Issue.prototype.getAssigneeUserId = function() {
  return /** @type{?proto.common.ObjectID} */ (
    jspb.Message.getWrapperField(this, proto_common_objectID_pb.ObjectID, 7));
};


/**
 * @param {?proto.common.ObjectID|undefined} value
 * @return {!proto.entity.Issue} returns this
*/
proto.entity.Issue.prototype.setAssigneeUserId = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.Issue} returns this
 */
proto.entity.Issue.prototype.clearAssigneeUserId = function() {
  return this.setAssigneeUserId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.Issue.prototype.hasAssigneeUserId = function() {
  return jspb.Message.getField(this, 7) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.entity.IssueDetails.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.IssueDetails.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.IssueDetails.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.IssueDetails} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.IssueDetails.toObject = function(includeInstance, msg) {
  var f, obj = {
    issueState: jspb.Message.getFieldWithDefault(msg, 1, 0),
    issueDisposition: jspb.Message.getFieldWithDefault(msg, 2, 0),
    dimensionsMap: (f = msg.getDimensionsMap()) ? f.toObject(includeInstance, undefined) : [],
    tagsList: (f = jspb.Message.getRepeatedField(msg, 4)) == null ? undefined : f,
    attributesMap: (f = msg.getAttributesMap()) ? f.toObject(includeInstance, undefined) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.IssueDetails}
 */
proto.entity.IssueDetails.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.IssueDetails;
  return proto.entity.IssueDetails.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.IssueDetails} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.IssueDetails}
 */
proto.entity.IssueDetails.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.entity.IssueState.Options} */ (reader.readEnum());
      msg.setIssueState(value);
      break;
    case 2:
      var value = /** @type {!proto.entity.IssueDisposition.Options} */ (reader.readEnum());
      msg.setIssueDisposition(value);
      break;
    case 3:
      var value = msg.getDimensionsMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "", "");
         });
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.addTags(value);
      break;
    case 5:
      var value = msg.getAttributesMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "", "");
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.IssueDetails.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.IssueDetails.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.IssueDetails} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.IssueDetails.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIssueState();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getIssueDisposition();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getDimensionsMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(3, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
  f = message.getTagsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      4,
      f
    );
  }
  f = message.getAttributesMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(5, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
};


/**
 * optional IssueState.Options issue_state = 1;
 * @return {!proto.entity.IssueState.Options}
 */
proto.entity.IssueDetails.prototype.getIssueState = function() {
  return /** @type {!proto.entity.IssueState.Options} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.entity.IssueState.Options} value
 * @return {!proto.entity.IssueDetails} returns this
 */
proto.entity.IssueDetails.prototype.setIssueState = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional IssueDisposition.Options issue_disposition = 2;
 * @return {!proto.entity.IssueDisposition.Options}
 */
proto.entity.IssueDetails.prototype.getIssueDisposition = function() {
  return /** @type {!proto.entity.IssueDisposition.Options} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.entity.IssueDisposition.Options} value
 * @return {!proto.entity.IssueDetails} returns this
 */
proto.entity.IssueDetails.prototype.setIssueDisposition = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * map<string, string> dimensions = 3;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.entity.IssueDetails.prototype.getDimensionsMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 3, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.entity.IssueDetails} returns this
 */
proto.entity.IssueDetails.prototype.clearDimensionsMap = function() {
  this.getDimensionsMap().clear();
  return this;};


/**
 * repeated string tags = 4;
 * @return {!Array<string>}
 */
proto.entity.IssueDetails.prototype.getTagsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 4));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.entity.IssueDetails} returns this
 */
proto.entity.IssueDetails.prototype.setTagsList = function(value) {
  return jspb.Message.setField(this, 4, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.entity.IssueDetails} returns this
 */
proto.entity.IssueDetails.prototype.addTags = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 4, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.entity.IssueDetails} returns this
 */
proto.entity.IssueDetails.prototype.clearTagsList = function() {
  return this.setTagsList([]);
};


/**
 * map<string, string> attributes = 5;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.entity.IssueDetails.prototype.getAttributesMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 5, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.entity.IssueDetails} returns this
 */
proto.entity.IssueDetails.prototype.clearAttributesMap = function() {
  this.getAttributesMap().clear();
  return this;};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.IssueState.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.IssueState.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.IssueState} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.IssueState.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.IssueState}
 */
proto.entity.IssueState.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.IssueState;
  return proto.entity.IssueState.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.IssueState} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.IssueState}
 */
proto.entity.IssueState.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.IssueState.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.IssueState.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.IssueState} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.IssueState.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * @enum {number}
 */
proto.entity.IssueState.Options = {
  UNSPECIFIED: 0,
  OPEN: 1,
  CLOSED: 2
};




if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.IssueDisposition.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.IssueDisposition.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.IssueDisposition} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.IssueDisposition.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.IssueDisposition}
 */
proto.entity.IssueDisposition.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.IssueDisposition;
  return proto.entity.IssueDisposition.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.IssueDisposition} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.IssueDisposition}
 */
proto.entity.IssueDisposition.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.IssueDisposition.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.IssueDisposition.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.IssueDisposition} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.IssueDisposition.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * @enum {number}
 */
proto.entity.IssueDisposition.Options = {
  UNSPECIFIED: 0,
  HIGHLY_USEFUL: 1,
  USEFUL: 2,
  NOT_USEFUL: 3
};


/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.entity.UpdateIssueAction.oneofGroups_ = [[1,2,7,3,4,5,6]];

/**
 * @enum {number}
 */
proto.entity.UpdateIssueAction.ActionCase = {
  ACTION_NOT_SET: 0,
  CHANGE_STATE: 1,
  UPDATE_TAGS: 2,
  UPDATE_ATTRIBUTES: 7,
  UPDATE_ASSIGNEE: 3,
  ADD_COMMENT: 4,
  DELETE_COMMENT: 5,
  EDIT_COMMENT: 6
};

/**
 * @return {proto.entity.UpdateIssueAction.ActionCase}
 */
proto.entity.UpdateIssueAction.prototype.getActionCase = function() {
  return /** @type {proto.entity.UpdateIssueAction.ActionCase} */(jspb.Message.computeOneofCase(this, proto.entity.UpdateIssueAction.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.UpdateIssueAction.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.UpdateIssueAction.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.UpdateIssueAction} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.UpdateIssueAction.toObject = function(includeInstance, msg) {
  var f, obj = {
    changeState: (f = msg.getChangeState()) && proto.entity.UpdateIssueAction.ChangeStateAction.toObject(includeInstance, f),
    updateTags: (f = msg.getUpdateTags()) && proto.entity.UpdateIssueAction.UpdateTagsAction.toObject(includeInstance, f),
    updateAttributes: (f = msg.getUpdateAttributes()) && proto.entity.UpdateIssueAction.UpdateAttributesAction.toObject(includeInstance, f),
    updateAssignee: (f = msg.getUpdateAssignee()) && proto.entity.UpdateIssueAction.UpdateAssigneeAction.toObject(includeInstance, f),
    addComment: (f = msg.getAddComment()) && proto.entity.UpdateIssueAction.AddIssueCommentAction.toObject(includeInstance, f),
    deleteComment: (f = msg.getDeleteComment()) && proto.entity.UpdateIssueAction.DeleteIssueCommentAction.toObject(includeInstance, f),
    editComment: (f = msg.getEditComment()) && proto.entity.UpdateIssueAction.EditIssueCommentAction.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.UpdateIssueAction}
 */
proto.entity.UpdateIssueAction.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.UpdateIssueAction;
  return proto.entity.UpdateIssueAction.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.UpdateIssueAction} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.UpdateIssueAction}
 */
proto.entity.UpdateIssueAction.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.entity.UpdateIssueAction.ChangeStateAction;
      reader.readMessage(value,proto.entity.UpdateIssueAction.ChangeStateAction.deserializeBinaryFromReader);
      msg.setChangeState(value);
      break;
    case 2:
      var value = new proto.entity.UpdateIssueAction.UpdateTagsAction;
      reader.readMessage(value,proto.entity.UpdateIssueAction.UpdateTagsAction.deserializeBinaryFromReader);
      msg.setUpdateTags(value);
      break;
    case 7:
      var value = new proto.entity.UpdateIssueAction.UpdateAttributesAction;
      reader.readMessage(value,proto.entity.UpdateIssueAction.UpdateAttributesAction.deserializeBinaryFromReader);
      msg.setUpdateAttributes(value);
      break;
    case 3:
      var value = new proto.entity.UpdateIssueAction.UpdateAssigneeAction;
      reader.readMessage(value,proto.entity.UpdateIssueAction.UpdateAssigneeAction.deserializeBinaryFromReader);
      msg.setUpdateAssignee(value);
      break;
    case 4:
      var value = new proto.entity.UpdateIssueAction.AddIssueCommentAction;
      reader.readMessage(value,proto.entity.UpdateIssueAction.AddIssueCommentAction.deserializeBinaryFromReader);
      msg.setAddComment(value);
      break;
    case 5:
      var value = new proto.entity.UpdateIssueAction.DeleteIssueCommentAction;
      reader.readMessage(value,proto.entity.UpdateIssueAction.DeleteIssueCommentAction.deserializeBinaryFromReader);
      msg.setDeleteComment(value);
      break;
    case 6:
      var value = new proto.entity.UpdateIssueAction.EditIssueCommentAction;
      reader.readMessage(value,proto.entity.UpdateIssueAction.EditIssueCommentAction.deserializeBinaryFromReader);
      msg.setEditComment(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.UpdateIssueAction.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.UpdateIssueAction.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.UpdateIssueAction} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.UpdateIssueAction.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getChangeState();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.entity.UpdateIssueAction.ChangeStateAction.serializeBinaryToWriter
    );
  }
  f = message.getUpdateTags();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.entity.UpdateIssueAction.UpdateTagsAction.serializeBinaryToWriter
    );
  }
  f = message.getUpdateAttributes();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.entity.UpdateIssueAction.UpdateAttributesAction.serializeBinaryToWriter
    );
  }
  f = message.getUpdateAssignee();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.entity.UpdateIssueAction.UpdateAssigneeAction.serializeBinaryToWriter
    );
  }
  f = message.getAddComment();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.entity.UpdateIssueAction.AddIssueCommentAction.serializeBinaryToWriter
    );
  }
  f = message.getDeleteComment();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.entity.UpdateIssueAction.DeleteIssueCommentAction.serializeBinaryToWriter
    );
  }
  f = message.getEditComment();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.entity.UpdateIssueAction.EditIssueCommentAction.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.UpdateIssueAction.ChangeStateAction.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.UpdateIssueAction.ChangeStateAction.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.UpdateIssueAction.ChangeStateAction} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.UpdateIssueAction.ChangeStateAction.toObject = function(includeInstance, msg) {
  var f, obj = {
    newState: jspb.Message.getFieldWithDefault(msg, 1, 0),
    newDisposition: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.UpdateIssueAction.ChangeStateAction}
 */
proto.entity.UpdateIssueAction.ChangeStateAction.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.UpdateIssueAction.ChangeStateAction;
  return proto.entity.UpdateIssueAction.ChangeStateAction.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.UpdateIssueAction.ChangeStateAction} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.UpdateIssueAction.ChangeStateAction}
 */
proto.entity.UpdateIssueAction.ChangeStateAction.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.entity.IssueState.Options} */ (reader.readEnum());
      msg.setNewState(value);
      break;
    case 2:
      var value = /** @type {!proto.entity.IssueDisposition.Options} */ (reader.readEnum());
      msg.setNewDisposition(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.UpdateIssueAction.ChangeStateAction.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.UpdateIssueAction.ChangeStateAction.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.UpdateIssueAction.ChangeStateAction} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.UpdateIssueAction.ChangeStateAction.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNewState();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getNewDisposition();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * optional IssueState.Options new_state = 1;
 * @return {!proto.entity.IssueState.Options}
 */
proto.entity.UpdateIssueAction.ChangeStateAction.prototype.getNewState = function() {
  return /** @type {!proto.entity.IssueState.Options} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.entity.IssueState.Options} value
 * @return {!proto.entity.UpdateIssueAction.ChangeStateAction} returns this
 */
proto.entity.UpdateIssueAction.ChangeStateAction.prototype.setNewState = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional IssueDisposition.Options new_disposition = 2;
 * @return {!proto.entity.IssueDisposition.Options}
 */
proto.entity.UpdateIssueAction.ChangeStateAction.prototype.getNewDisposition = function() {
  return /** @type {!proto.entity.IssueDisposition.Options} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.entity.IssueDisposition.Options} value
 * @return {!proto.entity.UpdateIssueAction.ChangeStateAction} returns this
 */
proto.entity.UpdateIssueAction.ChangeStateAction.prototype.setNewDisposition = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.entity.UpdateIssueAction.UpdateTagsAction.repeatedFields_ = [1,2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.UpdateIssueAction.UpdateTagsAction.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.UpdateIssueAction.UpdateTagsAction.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.UpdateIssueAction.UpdateTagsAction} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.UpdateIssueAction.UpdateTagsAction.toObject = function(includeInstance, msg) {
  var f, obj = {
    addTagsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
    removeTagsList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.UpdateIssueAction.UpdateTagsAction}
 */
proto.entity.UpdateIssueAction.UpdateTagsAction.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.UpdateIssueAction.UpdateTagsAction;
  return proto.entity.UpdateIssueAction.UpdateTagsAction.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.UpdateIssueAction.UpdateTagsAction} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.UpdateIssueAction.UpdateTagsAction}
 */
proto.entity.UpdateIssueAction.UpdateTagsAction.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addAddTags(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addRemoveTags(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.UpdateIssueAction.UpdateTagsAction.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.UpdateIssueAction.UpdateTagsAction.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.UpdateIssueAction.UpdateTagsAction} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.UpdateIssueAction.UpdateTagsAction.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAddTagsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
  f = message.getRemoveTagsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
};


/**
 * repeated string add_tags = 1;
 * @return {!Array<string>}
 */
proto.entity.UpdateIssueAction.UpdateTagsAction.prototype.getAddTagsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.entity.UpdateIssueAction.UpdateTagsAction} returns this
 */
proto.entity.UpdateIssueAction.UpdateTagsAction.prototype.setAddTagsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.entity.UpdateIssueAction.UpdateTagsAction} returns this
 */
proto.entity.UpdateIssueAction.UpdateTagsAction.prototype.addAddTags = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.entity.UpdateIssueAction.UpdateTagsAction} returns this
 */
proto.entity.UpdateIssueAction.UpdateTagsAction.prototype.clearAddTagsList = function() {
  return this.setAddTagsList([]);
};


/**
 * repeated string remove_tags = 2;
 * @return {!Array<string>}
 */
proto.entity.UpdateIssueAction.UpdateTagsAction.prototype.getRemoveTagsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.entity.UpdateIssueAction.UpdateTagsAction} returns this
 */
proto.entity.UpdateIssueAction.UpdateTagsAction.prototype.setRemoveTagsList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.entity.UpdateIssueAction.UpdateTagsAction} returns this
 */
proto.entity.UpdateIssueAction.UpdateTagsAction.prototype.addRemoveTags = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.entity.UpdateIssueAction.UpdateTagsAction} returns this
 */
proto.entity.UpdateIssueAction.UpdateTagsAction.prototype.clearRemoveTagsList = function() {
  return this.setRemoveTagsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.entity.UpdateIssueAction.UpdateAttributesAction.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.UpdateIssueAction.UpdateAttributesAction.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.UpdateIssueAction.UpdateAttributesAction.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.UpdateIssueAction.UpdateAttributesAction} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.UpdateIssueAction.UpdateAttributesAction.toObject = function(includeInstance, msg) {
  var f, obj = {
    updateAttributesMap: (f = msg.getUpdateAttributesMap()) ? f.toObject(includeInstance, undefined) : [],
    removeAttributesList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.UpdateIssueAction.UpdateAttributesAction}
 */
proto.entity.UpdateIssueAction.UpdateAttributesAction.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.UpdateIssueAction.UpdateAttributesAction;
  return proto.entity.UpdateIssueAction.UpdateAttributesAction.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.UpdateIssueAction.UpdateAttributesAction} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.UpdateIssueAction.UpdateAttributesAction}
 */
proto.entity.UpdateIssueAction.UpdateAttributesAction.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = msg.getUpdateAttributesMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "", "");
         });
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addRemoveAttributes(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.UpdateIssueAction.UpdateAttributesAction.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.UpdateIssueAction.UpdateAttributesAction.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.UpdateIssueAction.UpdateAttributesAction} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.UpdateIssueAction.UpdateAttributesAction.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUpdateAttributesMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(1, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
  f = message.getRemoveAttributesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
};


/**
 * map<string, string> update_attributes = 1;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.entity.UpdateIssueAction.UpdateAttributesAction.prototype.getUpdateAttributesMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 1, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.entity.UpdateIssueAction.UpdateAttributesAction} returns this
 */
proto.entity.UpdateIssueAction.UpdateAttributesAction.prototype.clearUpdateAttributesMap = function() {
  this.getUpdateAttributesMap().clear();
  return this;};


/**
 * repeated string remove_attributes = 2;
 * @return {!Array<string>}
 */
proto.entity.UpdateIssueAction.UpdateAttributesAction.prototype.getRemoveAttributesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.entity.UpdateIssueAction.UpdateAttributesAction} returns this
 */
proto.entity.UpdateIssueAction.UpdateAttributesAction.prototype.setRemoveAttributesList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.entity.UpdateIssueAction.UpdateAttributesAction} returns this
 */
proto.entity.UpdateIssueAction.UpdateAttributesAction.prototype.addRemoveAttributes = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.entity.UpdateIssueAction.UpdateAttributesAction} returns this
 */
proto.entity.UpdateIssueAction.UpdateAttributesAction.prototype.clearRemoveAttributesList = function() {
  return this.setRemoveAttributesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.UpdateIssueAction.UpdateAssigneeAction.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.UpdateIssueAction.UpdateAssigneeAction.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.UpdateIssueAction.UpdateAssigneeAction} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.UpdateIssueAction.UpdateAssigneeAction.toObject = function(includeInstance, msg) {
  var f, obj = {
    newAssigneeUser: (f = msg.getNewAssigneeUser()) && proto_entity_user_pb.UserSelector.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.UpdateIssueAction.UpdateAssigneeAction}
 */
proto.entity.UpdateIssueAction.UpdateAssigneeAction.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.UpdateIssueAction.UpdateAssigneeAction;
  return proto.entity.UpdateIssueAction.UpdateAssigneeAction.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.UpdateIssueAction.UpdateAssigneeAction} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.UpdateIssueAction.UpdateAssigneeAction}
 */
proto.entity.UpdateIssueAction.UpdateAssigneeAction.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_user_pb.UserSelector;
      reader.readMessage(value,proto_entity_user_pb.UserSelector.deserializeBinaryFromReader);
      msg.setNewAssigneeUser(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.UpdateIssueAction.UpdateAssigneeAction.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.UpdateIssueAction.UpdateAssigneeAction.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.UpdateIssueAction.UpdateAssigneeAction} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.UpdateIssueAction.UpdateAssigneeAction.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNewAssigneeUser();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_entity_user_pb.UserSelector.serializeBinaryToWriter
    );
  }
};


/**
 * optional UserSelector new_assignee_user = 1;
 * @return {?proto.entity.UserSelector}
 */
proto.entity.UpdateIssueAction.UpdateAssigneeAction.prototype.getNewAssigneeUser = function() {
  return /** @type{?proto.entity.UserSelector} */ (
    jspb.Message.getWrapperField(this, proto_entity_user_pb.UserSelector, 1));
};


/**
 * @param {?proto.entity.UserSelector|undefined} value
 * @return {!proto.entity.UpdateIssueAction.UpdateAssigneeAction} returns this
*/
proto.entity.UpdateIssueAction.UpdateAssigneeAction.prototype.setNewAssigneeUser = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.UpdateIssueAction.UpdateAssigneeAction} returns this
 */
proto.entity.UpdateIssueAction.UpdateAssigneeAction.prototype.clearNewAssigneeUser = function() {
  return this.setNewAssigneeUser(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.UpdateIssueAction.UpdateAssigneeAction.prototype.hasNewAssigneeUser = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.UpdateIssueAction.AddIssueCommentAction.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.UpdateIssueAction.AddIssueCommentAction.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.UpdateIssueAction.AddIssueCommentAction} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.UpdateIssueAction.AddIssueCommentAction.toObject = function(includeInstance, msg) {
  var f, obj = {
    newComment: (f = msg.getNewComment()) && proto_entity_comment_pb.NewComment.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.UpdateIssueAction.AddIssueCommentAction}
 */
proto.entity.UpdateIssueAction.AddIssueCommentAction.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.UpdateIssueAction.AddIssueCommentAction;
  return proto.entity.UpdateIssueAction.AddIssueCommentAction.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.UpdateIssueAction.AddIssueCommentAction} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.UpdateIssueAction.AddIssueCommentAction}
 */
proto.entity.UpdateIssueAction.AddIssueCommentAction.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_comment_pb.NewComment;
      reader.readMessage(value,proto_entity_comment_pb.NewComment.deserializeBinaryFromReader);
      msg.setNewComment(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.UpdateIssueAction.AddIssueCommentAction.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.UpdateIssueAction.AddIssueCommentAction.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.UpdateIssueAction.AddIssueCommentAction} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.UpdateIssueAction.AddIssueCommentAction.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNewComment();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_entity_comment_pb.NewComment.serializeBinaryToWriter
    );
  }
};


/**
 * optional NewComment new_comment = 1;
 * @return {?proto.entity.NewComment}
 */
proto.entity.UpdateIssueAction.AddIssueCommentAction.prototype.getNewComment = function() {
  return /** @type{?proto.entity.NewComment} */ (
    jspb.Message.getWrapperField(this, proto_entity_comment_pb.NewComment, 1));
};


/**
 * @param {?proto.entity.NewComment|undefined} value
 * @return {!proto.entity.UpdateIssueAction.AddIssueCommentAction} returns this
*/
proto.entity.UpdateIssueAction.AddIssueCommentAction.prototype.setNewComment = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.UpdateIssueAction.AddIssueCommentAction} returns this
 */
proto.entity.UpdateIssueAction.AddIssueCommentAction.prototype.clearNewComment = function() {
  return this.setNewComment(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.UpdateIssueAction.AddIssueCommentAction.prototype.hasNewComment = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.UpdateIssueAction.DeleteIssueCommentAction.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.UpdateIssueAction.DeleteIssueCommentAction.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.UpdateIssueAction.DeleteIssueCommentAction} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.UpdateIssueAction.DeleteIssueCommentAction.toObject = function(includeInstance, msg) {
  var f, obj = {
    commentId: (f = msg.getCommentId()) && proto_common_objectID_pb.ObjectID.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.UpdateIssueAction.DeleteIssueCommentAction}
 */
proto.entity.UpdateIssueAction.DeleteIssueCommentAction.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.UpdateIssueAction.DeleteIssueCommentAction;
  return proto.entity.UpdateIssueAction.DeleteIssueCommentAction.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.UpdateIssueAction.DeleteIssueCommentAction} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.UpdateIssueAction.DeleteIssueCommentAction}
 */
proto.entity.UpdateIssueAction.DeleteIssueCommentAction.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_common_objectID_pb.ObjectID;
      reader.readMessage(value,proto_common_objectID_pb.ObjectID.deserializeBinaryFromReader);
      msg.setCommentId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.UpdateIssueAction.DeleteIssueCommentAction.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.UpdateIssueAction.DeleteIssueCommentAction.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.UpdateIssueAction.DeleteIssueCommentAction} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.UpdateIssueAction.DeleteIssueCommentAction.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommentId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_common_objectID_pb.ObjectID.serializeBinaryToWriter
    );
  }
};


/**
 * optional common.ObjectID comment_id = 1;
 * @return {?proto.common.ObjectID}
 */
proto.entity.UpdateIssueAction.DeleteIssueCommentAction.prototype.getCommentId = function() {
  return /** @type{?proto.common.ObjectID} */ (
    jspb.Message.getWrapperField(this, proto_common_objectID_pb.ObjectID, 1));
};


/**
 * @param {?proto.common.ObjectID|undefined} value
 * @return {!proto.entity.UpdateIssueAction.DeleteIssueCommentAction} returns this
*/
proto.entity.UpdateIssueAction.DeleteIssueCommentAction.prototype.setCommentId = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.UpdateIssueAction.DeleteIssueCommentAction} returns this
 */
proto.entity.UpdateIssueAction.DeleteIssueCommentAction.prototype.clearCommentId = function() {
  return this.setCommentId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.UpdateIssueAction.DeleteIssueCommentAction.prototype.hasCommentId = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.UpdateIssueAction.EditIssueCommentAction.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.UpdateIssueAction.EditIssueCommentAction.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.UpdateIssueAction.EditIssueCommentAction} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.UpdateIssueAction.EditIssueCommentAction.toObject = function(includeInstance, msg) {
  var f, obj = {
    commentId: (f = msg.getCommentId()) && proto_common_objectID_pb.ObjectID.toObject(includeInstance, f),
    newText: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.UpdateIssueAction.EditIssueCommentAction}
 */
proto.entity.UpdateIssueAction.EditIssueCommentAction.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.UpdateIssueAction.EditIssueCommentAction;
  return proto.entity.UpdateIssueAction.EditIssueCommentAction.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.UpdateIssueAction.EditIssueCommentAction} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.UpdateIssueAction.EditIssueCommentAction}
 */
proto.entity.UpdateIssueAction.EditIssueCommentAction.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_common_objectID_pb.ObjectID;
      reader.readMessage(value,proto_common_objectID_pb.ObjectID.deserializeBinaryFromReader);
      msg.setCommentId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setNewText(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.UpdateIssueAction.EditIssueCommentAction.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.UpdateIssueAction.EditIssueCommentAction.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.UpdateIssueAction.EditIssueCommentAction} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.UpdateIssueAction.EditIssueCommentAction.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommentId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_common_objectID_pb.ObjectID.serializeBinaryToWriter
    );
  }
  f = message.getNewText();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional common.ObjectID comment_id = 1;
 * @return {?proto.common.ObjectID}
 */
proto.entity.UpdateIssueAction.EditIssueCommentAction.prototype.getCommentId = function() {
  return /** @type{?proto.common.ObjectID} */ (
    jspb.Message.getWrapperField(this, proto_common_objectID_pb.ObjectID, 1));
};


/**
 * @param {?proto.common.ObjectID|undefined} value
 * @return {!proto.entity.UpdateIssueAction.EditIssueCommentAction} returns this
*/
proto.entity.UpdateIssueAction.EditIssueCommentAction.prototype.setCommentId = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.UpdateIssueAction.EditIssueCommentAction} returns this
 */
proto.entity.UpdateIssueAction.EditIssueCommentAction.prototype.clearCommentId = function() {
  return this.setCommentId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.UpdateIssueAction.EditIssueCommentAction.prototype.hasCommentId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string new_text = 2;
 * @return {string}
 */
proto.entity.UpdateIssueAction.EditIssueCommentAction.prototype.getNewText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.UpdateIssueAction.EditIssueCommentAction} returns this
 */
proto.entity.UpdateIssueAction.EditIssueCommentAction.prototype.setNewText = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional ChangeStateAction change_state = 1;
 * @return {?proto.entity.UpdateIssueAction.ChangeStateAction}
 */
proto.entity.UpdateIssueAction.prototype.getChangeState = function() {
  return /** @type{?proto.entity.UpdateIssueAction.ChangeStateAction} */ (
    jspb.Message.getWrapperField(this, proto.entity.UpdateIssueAction.ChangeStateAction, 1));
};


/**
 * @param {?proto.entity.UpdateIssueAction.ChangeStateAction|undefined} value
 * @return {!proto.entity.UpdateIssueAction} returns this
*/
proto.entity.UpdateIssueAction.prototype.setChangeState = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.entity.UpdateIssueAction.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.UpdateIssueAction} returns this
 */
proto.entity.UpdateIssueAction.prototype.clearChangeState = function() {
  return this.setChangeState(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.UpdateIssueAction.prototype.hasChangeState = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional UpdateTagsAction update_tags = 2;
 * @return {?proto.entity.UpdateIssueAction.UpdateTagsAction}
 */
proto.entity.UpdateIssueAction.prototype.getUpdateTags = function() {
  return /** @type{?proto.entity.UpdateIssueAction.UpdateTagsAction} */ (
    jspb.Message.getWrapperField(this, proto.entity.UpdateIssueAction.UpdateTagsAction, 2));
};


/**
 * @param {?proto.entity.UpdateIssueAction.UpdateTagsAction|undefined} value
 * @return {!proto.entity.UpdateIssueAction} returns this
*/
proto.entity.UpdateIssueAction.prototype.setUpdateTags = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.entity.UpdateIssueAction.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.UpdateIssueAction} returns this
 */
proto.entity.UpdateIssueAction.prototype.clearUpdateTags = function() {
  return this.setUpdateTags(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.UpdateIssueAction.prototype.hasUpdateTags = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional UpdateAttributesAction update_attributes = 7;
 * @return {?proto.entity.UpdateIssueAction.UpdateAttributesAction}
 */
proto.entity.UpdateIssueAction.prototype.getUpdateAttributes = function() {
  return /** @type{?proto.entity.UpdateIssueAction.UpdateAttributesAction} */ (
    jspb.Message.getWrapperField(this, proto.entity.UpdateIssueAction.UpdateAttributesAction, 7));
};


/**
 * @param {?proto.entity.UpdateIssueAction.UpdateAttributesAction|undefined} value
 * @return {!proto.entity.UpdateIssueAction} returns this
*/
proto.entity.UpdateIssueAction.prototype.setUpdateAttributes = function(value) {
  return jspb.Message.setOneofWrapperField(this, 7, proto.entity.UpdateIssueAction.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.UpdateIssueAction} returns this
 */
proto.entity.UpdateIssueAction.prototype.clearUpdateAttributes = function() {
  return this.setUpdateAttributes(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.UpdateIssueAction.prototype.hasUpdateAttributes = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional UpdateAssigneeAction update_assignee = 3;
 * @return {?proto.entity.UpdateIssueAction.UpdateAssigneeAction}
 */
proto.entity.UpdateIssueAction.prototype.getUpdateAssignee = function() {
  return /** @type{?proto.entity.UpdateIssueAction.UpdateAssigneeAction} */ (
    jspb.Message.getWrapperField(this, proto.entity.UpdateIssueAction.UpdateAssigneeAction, 3));
};


/**
 * @param {?proto.entity.UpdateIssueAction.UpdateAssigneeAction|undefined} value
 * @return {!proto.entity.UpdateIssueAction} returns this
*/
proto.entity.UpdateIssueAction.prototype.setUpdateAssignee = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.entity.UpdateIssueAction.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.UpdateIssueAction} returns this
 */
proto.entity.UpdateIssueAction.prototype.clearUpdateAssignee = function() {
  return this.setUpdateAssignee(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.UpdateIssueAction.prototype.hasUpdateAssignee = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional AddIssueCommentAction add_comment = 4;
 * @return {?proto.entity.UpdateIssueAction.AddIssueCommentAction}
 */
proto.entity.UpdateIssueAction.prototype.getAddComment = function() {
  return /** @type{?proto.entity.UpdateIssueAction.AddIssueCommentAction} */ (
    jspb.Message.getWrapperField(this, proto.entity.UpdateIssueAction.AddIssueCommentAction, 4));
};


/**
 * @param {?proto.entity.UpdateIssueAction.AddIssueCommentAction|undefined} value
 * @return {!proto.entity.UpdateIssueAction} returns this
*/
proto.entity.UpdateIssueAction.prototype.setAddComment = function(value) {
  return jspb.Message.setOneofWrapperField(this, 4, proto.entity.UpdateIssueAction.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.UpdateIssueAction} returns this
 */
proto.entity.UpdateIssueAction.prototype.clearAddComment = function() {
  return this.setAddComment(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.UpdateIssueAction.prototype.hasAddComment = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional DeleteIssueCommentAction delete_comment = 5;
 * @return {?proto.entity.UpdateIssueAction.DeleteIssueCommentAction}
 */
proto.entity.UpdateIssueAction.prototype.getDeleteComment = function() {
  return /** @type{?proto.entity.UpdateIssueAction.DeleteIssueCommentAction} */ (
    jspb.Message.getWrapperField(this, proto.entity.UpdateIssueAction.DeleteIssueCommentAction, 5));
};


/**
 * @param {?proto.entity.UpdateIssueAction.DeleteIssueCommentAction|undefined} value
 * @return {!proto.entity.UpdateIssueAction} returns this
*/
proto.entity.UpdateIssueAction.prototype.setDeleteComment = function(value) {
  return jspb.Message.setOneofWrapperField(this, 5, proto.entity.UpdateIssueAction.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.UpdateIssueAction} returns this
 */
proto.entity.UpdateIssueAction.prototype.clearDeleteComment = function() {
  return this.setDeleteComment(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.UpdateIssueAction.prototype.hasDeleteComment = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional EditIssueCommentAction edit_comment = 6;
 * @return {?proto.entity.UpdateIssueAction.EditIssueCommentAction}
 */
proto.entity.UpdateIssueAction.prototype.getEditComment = function() {
  return /** @type{?proto.entity.UpdateIssueAction.EditIssueCommentAction} */ (
    jspb.Message.getWrapperField(this, proto.entity.UpdateIssueAction.EditIssueCommentAction, 6));
};


/**
 * @param {?proto.entity.UpdateIssueAction.EditIssueCommentAction|undefined} value
 * @return {!proto.entity.UpdateIssueAction} returns this
*/
proto.entity.UpdateIssueAction.prototype.setEditComment = function(value) {
  return jspb.Message.setOneofWrapperField(this, 6, proto.entity.UpdateIssueAction.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.UpdateIssueAction} returns this
 */
proto.entity.UpdateIssueAction.prototype.clearEditComment = function() {
  return this.setEditComment(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.UpdateIssueAction.prototype.hasEditComment = function() {
  return jspb.Message.getField(this, 6) != null;
};


goog.object.extend(exports, proto.entity);
